module.exports = __webpack_public_path__ + "img/rubin-img-06.eeeffefa.jpg";